import { useEffect, useState } from "react";

import requestVacios from "./Interfaces/requestVacios";
import { postData } from "./Http/api";

const Organismo = () => {
  const [rows, setRows] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await postData("/OrganismoListar");

        const data = response.value.map((item) => ({
          idOrganismo: item.idOrganismo,
          descripcion: item.denominacion,
          activo: item.activo
        }));

        setRows(data);
      } catch (ex) {
        console.error("Error cargando Organismos:", ex);
        setRows([]);
      }
    };

    fetchData();
  }, []);

  return rows;
};

// Named async helper for non-hook consumers
export const fetchOrganismos = async () => {
  try {
    const response = await postData("/OrganismoListar", {});
    return (response?.value || []).map((item) => ({
      idOrganismo: item.idOrganismo,
      descripcion: item.denominacion,
      activo: item.activo,
    }));
  } catch (ex) {
    console.error("Error cargando Organismos (helper):", ex);
    return [];
  }
};

export default Organismo;
